import React, { Component } from 'react';
import { Link } from 'react-router';

let $ = window.jQuery;

export default class FABMultiple extends Component {
    state = {
        openMenu: false
    };

    handleSubMenuClick = (e) => {
        $('#hamburger').toggleClass('showFab');
        $('#overlay').toggleClass('showFab');
        $('.fabNav').toggleClass('showFab');

        this.setState({
            openMenu: !this.state.openMenu
        });

        this.props.newAppointment();
    };

    componentDidMount() {
        $('#hamburger').click(() => {
            $('#hamburger').toggleClass('showFab');
            $('#overlay').toggleClass('showFab');
            $('.fabNav').toggleClass('showFab');

            this.setState({
                openMenu: !this.state.openMenu
            });
        });
    }

    render() {
        return (
            <div>
                <div id="overlay"></div>
                <div id="hamburger">
                    <div id="wrapper">
                        <span className="icon-bar" id="one"/>
                        <span className="icon-bar" id="two"/>
                        <span className="icon-bar" id="thr"/>
                    </div>
                </div>

                <Link to="/patients/new_patient" className="fabNav thumb"
                      id="newPatientFab"
                      onClick={this.handleSubMenuClick}
                      style={(this.state.openMenu) ? { WebkitTransform: 'translateY(-125%)', transform: 'translateY(-125%)' } : {}}>

                    <i className="fa fa-user fab-icons"/>
                    <p className="fabLabel">New Patient</p>
                </Link>

                <a href="#newAppointmentModal" data-toggle="modal"
                   className="fabNav thumb" id="newAppointmentFab"
                   onClick={this.handleSubMenuClick}
                   style={(this.state.openMenu) ? { WebkitTransform: 'translateY(-250%)', transform: 'translateY(-250%)' } : {}}>

                    <i className="fa fa-book fab-icons"/>
                    <p className="fabLabel">New Appointment</p>
                </a>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/commons/Buttons/FABMultiple.js
 **/